import React from "react";

const Block = ({ className = "" }) => (
  <div className={`bg-gray-200 rounded ${className}`} />
);

const PageSkeleton = () => (
  <div className="flex flex-col h-full w-full min-h-0 flex-1 p-4 gap-4 animate-pulse">
    <div className="flex items-center gap-3 pb-3 border-b border-gray-200">
      <Block className="h-10 w-10 rounded-full" />
      <div className="flex-1 flex flex-col gap-2">
        <Block className="h-4 w-1/3" />
        <Block className="h-3 w-1/4" />
      </div>
      <Block className="h-8 w-24" />
      <Block className="h-8 w-8 rounded-full" />
    </div>

    <div className="flex-1 flex flex-col gap-4 overflow-hidden">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="flex items-start gap-3">
          <Block className="h-9 w-9 rounded-full shrink-0" />
          <div className="flex-1 flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <Block className="h-3 w-32" />
              <Block className="h-3 w-16" />
            </div>
            <Block className="h-3 w-3/4" />
            <Block className="h-3 w-1/2" />
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default PageSkeleton;
